import { getToken } from "./auth";

const apiCall = (
  method,
  url,
  payload,
  headers = { "Content-Type": "application/json" }
) => {
  return new Promise((resolve, reject) => {
    const requestOptions = {
      method: method,
      headers: {
        ...headers,
        Authorization: `Bearer ${getToken()}`,
      },
    };
    if (payload) requestOptions.body = JSON.stringify(payload);
    fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          response.json().then((r) => {
            reject({
              detail: r?.detail,
              isError: true,
              color: 'red'
            });
          });
        } else return response.json().then((data) => resolve({
          ...data,
          isError: false
        }));
      })
      .catch((e) => reject(e));
  });
};

export default apiCall;
